<template>
  <html lang="pt-br">
    <head>      
      <meta name="description" content="Artigos e Publicações">

      <component-head-style/>
    </head>

    <body class="body-wrapper" data-spy="scroll" data-target=".privacy-nav">
      <component-nav-bar/>

        <section class="section about p-0">
          <div class="container" style="margin-top:80px">
            <div class="row">
              <div class="col-lg-6 align-self-center">
                <div class="content text-center text-lg-left">
                  <h2>Passo a Passo para protocolar recursos de ICMS</h2>

                  <p>
                    Primeiro é necessário acessar o portal ICMS Transparente (<a href="https://efazenda.servicos.ms.gov.br/e-fazenda/login.aspx" target="_blank">clique aqui</a>) 
                    com o certificado digital e e-CNPJ do município.
                    <br><br>
                    Em seguida, acesse o menu <i><b>Solicitação de abertura de protocolo</b></i>.
                    <br>
                    Após abertas as opções, selecione <i><b>Criar uma solicitação</b></i>.
                    <br><br>
                    Nos dados de solicitação, haverá um seletor de Tipo de solicitação. Nesse selecione a opção <i><b>IMPUGNAÇÃO AO ÍNDICE DE PARTICIPAÇÃO DOS MUNICÍPIOS (IPM)</b></i>, 
                    em seguida escolha o arquivo anexado na plataforma.
                    <br><br>
                    Para concluir basta clicar em <i><b>Salvar</b></i>.
                    <br><br>
                    Preparamos um PDF com os prints do passo a passo: 
                    <a style="color: blue;" href="https://drive.google.com/file/d/1fZ4Q96lgYjrKazrMM-7SWpb_JfDvAXtb/view?usp=sharing" target="_blank">download</a>
                    <br><br>
                    Caso tenha ficado com dúvidas, entre em contato conosco através do botão abaixo.
                  </p>
                </div>
              </div>

              <div class="col-lg-6 mt-4 mt-lg-0">
                <div class="about-slider">
                  <div class="item">
                    <img class="w-100" 
                          src="../../assets/images/ibcgp/publications/maxrecursoicms.png" 
                          alt="Imagem de valores do instituto"
                          style="border-radius: 15px;">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

      <section class="section cta-hire bg-gary">
        <contact/>
      </section>

      <component-footer/>

      <btn-to-top/>
    </body>

    <component-body-scripts/>
  </html>
</template>

<script>
  import Head from '../structure/Head.vue';
  import Navbar from '../structure/Navbar.vue';

  import Contact from '../contact/ShortcutContact.vue';

  import Footer from '../structure/Footer.vue';
  import BtnToTop from '../structure/BtnToTop.vue';
  import BodyScripts from '../structure/BodyScripts.vue';

  export default {
    created(){
      document.title = "IBCGP | Artigos e Publicações";
    },
    components:{
      'component-head-style'    : Head,
      'component-nav-bar'       : Navbar,

      'contact'                 : Contact,

      'component-footer'        : Footer,
      'btn-to-top'              : BtnToTop,
      'component-body-scripts'  : BodyScripts
    },
    beforeMount() {
      this.navPublications = true;
    }
  }
</script>